import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Bundles
export const fetchBundles = () => api.get("/bundles").then((r) => r.data);

// Custom Requests
export const submitCustomRequest = (payload) =>
  api.post("/custom-requests", payload).then((r) => r.data);

// Checkout / Payments
export const createCheckoutSession = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);

export const createMockCheckoutSession = (payload) =>
  api.post("/checkout/mock-session", payload).then((r) => r.data);

// Auth
export const exchangeSession = (sessionId) =>
  api.post("/auth/session", { session_id: sessionId }, { withCredentials: true })
    .then((r) => r.data);

export const fetchMe = () =>
  api.get("/auth/me", { withCredentials: true }).then((r) => r.data);

export const logout = () =>
  api.post("/auth/logout", {}, { withCredentials: true }).then((r) => r.data);

// Admin
export const adminStats = () =>
  api.get("/admin/stats", { withCredentials: true }).then((r) => r.data);

export const adminListOrders = (status) =>
  api.get("/admin/orders", { withCredentials: true, params: status ? { status } : {} })
    .then((r) => r.data);

export const adminGetOrder = (orderNumber) =>
  api.get(`/admin/orders/${orderNumber}`, { withCredentials: true }).then((r) => r.data);

export const adminUpdateOrderStatus = (orderNumber, status, note = "") =>
  api.put(`/admin/orders/${orderNumber}/status`, { status, note }, { withCredentials: true })
    .then((r) => r.data);

export const adminListCustomRequests = () =>
  api.get("/admin/custom-requests", { withCredentials: true }).then((r) => r.data);

export const adminListDesignDetails = () =>
  api.get("/admin/design-details", { withCredentials: true }).then((r) => r.data);

// Uploads
export const uploadInspirationImage = (file, orderNumber) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/uploads?orderNumber=${encodeURIComponent(orderNumber)}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};

export const listUploads = (orderNumber) =>
  api.get(`/uploads/by-order/${encodeURIComponent(orderNumber)}`).then((r) => r.data);

export const deleteUpload = (fileId) =>
  api.delete(`/uploads/${fileId}`).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

// Orders
export const getOrder = (orderNumber) =>
  api.get(`/orders/${orderNumber}`).then((r) => r.data);

export const getOrdersByEmail = (email) =>
  api.get(`/orders/by-email/${encodeURIComponent(email)}`).then((r) => r.data);

// Design Details
export const saveDesignDraft = (payload) =>
  api.put("/design-details/draft", payload).then((r) => r.data);

export const getDesignDraft = (orderNumber) =>
  api.get(`/design-details/draft/${orderNumber}`).then((r) => r.data);

export const submitDesignDetails = (payload) =>
  api.post("/design-details", payload).then((r) => r.data);

export const getDesignDetailsByEmail = (email) =>
  api
    .get(`/design-details/by-email/${encodeURIComponent(email)}`)
    .then((r) => r.data);
